// extracted by mini-css-extract-plugin
module.exports = {"deviceSequence":"DeviceSequence--device-sequence--ILx80"};